export enum CredSubType {
  SkillsChecklist = 'skillsChecklist',
  AssignmentCredential = 'assignmentCredential',
  ActionItem = 'actionItem',
  UserCredential = 'userCredential',
}
